
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as helprI5zHuKNHvrIiu5BHMoJJulzSXZmV875mxwgaIgcgnIMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/help.vue?macro=true";
import { default as indexjMYzAYOqPrOoUNRPe_45hZ8qfNRETGn3rVX3i6SLBrVYMMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/index.vue?macro=true";
import { default as loginRY5pVAHNAiBy4jVwdsOyuRHQxajIl5a0OEto5VxLsS0Meta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/login.vue?macro=true";
import { default as logoutb04bx8vEbZfwsMC9_45ft8jhp_S4xsO7HEjtwclM6oDogMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/logout.vue?macro=true";
import { default as privacyYAfuxGKNqN9CkdUzrRGaCVB_6bdQGYVeUww2wcLrrMQMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/privacy.vue?macro=true";
import { default as newHhNZSsPw86v_45crBznLBvOd6YAZ8qBCQ5KX_hnVMCFbkMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/rie/new.vue?macro=true";
import { default as indexTAg_45GDTNIb0tduAXM4fHMrRqBAJAUJgtWdOXQ3E87kUMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/rie/index.vue?macro=true";
import { default as editLrlqi9LrcbGLZZw3XOSU5UYwernZe0TAxIRcCAUTrmwMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/rie/[rieId]/edit.vue?macro=true";
import { default as indexctiu9Sf7RL95p03SBO54LZosl9EBSQ0fbCZfAorW2WEMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/rie/[rieId]/index.vue?macro=true";
import { default as riedUqUeTbgcyACnXQpxS2CQrEx5uuyGwtKvAI46bc_45nKYMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/rie.vue?macro=true";
import { default as indexQoYH_45KDt3HY4y0nTaAxanVb0fQJYm53O3ah7hPf2Sj8Meta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/index.vue?macro=true";
import { default as indexrPyrRtpzk2POXSTKfR_IU3skZIRBaLYrqqls61rjOmAMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/risicos/index.vue?macro=true";
import { default as editsijRsS5_45vE2Wa_2o7aJnQnu8XtTWwPEZsyX3sjLt1WMMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/risicos/[riskId]/edit.vue?macro=true";
import { default as indexGpmPn6UV0OxqQ7jlzZUngoHx28YUYa9kVMjGbT_45qErkMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/risicos/[riskId]/index.vue?macro=true";
import { default as risicosyPMVIjZWUC1VNMYFwugCMlRO00_45kmClonGz0oP34FywMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/risicos.vue?macro=true";
import { default as dashboardOZ4kUpHOOQMUBBc9W25koILNJVOLDsjRSiGrA1mUTaQMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/dashboard.vue?macro=true";
import { default as indexp8r103lKWvLPUEpyPw098SRdLYcFNJ9ds0c_45Vtq2pT4Meta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/rapportage/index.vue?macro=true";
import { default as aanmaken0xY7bcyggNhRgrULqHImBXfTM88_45wsq1JMZY3s6d7EQMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/rapportage/aanmaken.vue?macro=true";
import { default as rapportagephZb8VnLEqWDv_8mecsj8_45gacp21WY_xsqiNQkWFgu4Meta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/rapportage.vue?macro=true";
import { default as index9s9MkXplFshKaW_xLZe_45Vy8InJ7pIjwzNXu9LMt_gz8Meta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/inventarisatie/index.vue?macro=true";
import { default as onderwerpenC3M_4133WEtEweNRUN0i5msVpBBDTtCY_3ZKetz9eHgMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/inventarisatie/onderwerpen.vue?macro=true";
import { default as endk7bOGGqkpm9YSP2_zn5XcRciSMv0TOBabTIPhZsQlgsMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/inventarisatie/[topicKey]/end.vue?macro=true";
import { default as indexiOa45rFI3x9S59TBNi9D4Sht8_45Jv8RjDrwJ8CAn_451TEMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/inventarisatie/[topicKey]/index.vue?macro=true";
import { default as _91questionKey_93qWhigDu1jPAu0gPXxTQsW3dU120uIkvvB_45QRCe6Z1ZYMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/inventarisatie/[topicKey]/[questionKey].vue?macro=true";
import { default as inventarisatiegXCUZcode63G2c728EM_45wqI9EPuC9A4DS0xxvrQ1nOAMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/inventarisatie.vue?macro=true";
import { default as indexKJ_ocGLjjSLHM_45HisHqffKI6jol_45tU6uiLKZR9pm1PEMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/plan-van-aanpak/index.vue?macro=true";
import { default as editQ5OeU6yxsxOzt2De1zRDLbKxIYzq1lrpLBvMOipMVFoMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/plan-van-aanpak/[actionId]/edit.vue?macro=true";
import { default as indexlQZqI9DMLpK601eHaFOsbDqsOcgOEOvgTbg2Zmu_kQgMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/plan-van-aanpak/[actionId]/index.vue?macro=true";
import { default as plan_45van_45aanpakJW_8JHBblcI84ufrC2KETdVu5ua7Ekisf6tDyBHHKrsMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/plan-van-aanpak.vue?macro=true";
import { default as indexk8AtROf2bkuB5Z_saipss2jHyn17oy0gK1bk9_zLh3gMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/stigas/werknemersvragenlijst/index.vue?macro=true";
import { default as _91rieId_93sDUUfG6fa5OD8_45HS7WgzoJfMiOpxwE6r5B613wpYpkcMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId].vue?macro=true";
import { default as indexth3NAHKiUDWSa8BIcQ9Y4O6PmdrMmY_459LYrUIKoueNEMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/gebruikers/index.vue?macro=true";
import { default as _91userId_93B5Bt_45Z7LAaWgACFqAfhcvm1LQboLcsOIGOlQ4aUp5HgMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/gebruikers/[userId].vue?macro=true";
import { default as uitnodigenPs4oWzm6eE_LvMl4wbnCB8mbL8xRJuReTvYw_45FhznQMMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/gebruikers/uitnodigen.vue?macro=true";
import { default as gebruikerssMjzsIwfYWun8dQ_IxDfFzt_45eP00DZF5ixHppV71h7kMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/gebruikers.vue?macro=true";
import { default as editILkwKMIsT_457BBOP_qZLCc7TnEXaR4CtOkQa_N6ixSQgMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/bedrijfsinformatie/edit.vue?macro=true";
import { default as indexr8sejWaWUT_BgKDSMVHD_XKEKsZUE6nDY4Fs6o90Q5sMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/bedrijfsinformatie/index.vue?macro=true";
import { default as bedrijfsinformatiePDcDvenn0ettSilaVhHDsxNkOCjUjRHs2zisbVCpGCYMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/bedrijfsinformatie.vue?macro=true";
import { default as _91id_93kkP8pOsCgBH_DtdY6_gaEtm8PI0cOEG4Z_45mUtvudrzAMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/verantwoordelijken/[id].vue?macro=true";
import { default as index7qLeRJY8OIQFSPWxEBBiot6idTURnt7ISbxJAqkpYLYMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/verantwoordelijken/index.vue?macro=true";
import { default as verantwoordelijkengFxkXY3wcx8r4Efmxl__45l585GZ_452eIafwLBR4UYGKfIMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/verantwoordelijken.vue?macro=true";
import { default as new5EkzMZ65HtWV1Z9TXjZyU_450w_458iVdjCI8TpkcRuUY3wMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/ongevallenregistratie/new.vue?macro=true";
import { default as index7FvY_H05EDtqKb_7LEe4CZIk67aB5uvMmM0W3vIROxkMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/ongevallenregistratie/index.vue?macro=true";
import { default as editXZbBnzlX76pZuZTRLWf7TTQPocGNYw36o609YFsUUDAMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/ongevallenregistratie/[accidentId]/edit.vue?macro=true";
import { default as indexTAogjmzEQt8uZY8iKe3RzB_45A4hladUtlaOQU9EPaHWEMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/ongevallenregistratie/[accidentId]/index.vue?macro=true";
import { default as _91accidentId_93dlAQMlAugwFmqCh60zIqCsuWL75fBEjrlvO9T6QFhPkMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/ongevallenregistratie/[accidentId].vue?macro=true";
import { default as achtergrondinformatieY6ECRA2lLb8bx_453RcRKDqfAipUfneQ6fau6Oll4sqckMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/ongevallenregistratie/achtergrondinformatie.vue?macro=true";
import { default as ongevallenregistratieD6hXoVbHkSn2N9radGPOVtxPWHeruvU4oyGzfWlEpX8Meta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/ongevallenregistratie.vue?macro=true";
import { default as _91companyId_93wG_4569ps_pLTeOKGntd2VqRFXfcMUK_45OjU77JsmL1tpEMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId].vue?macro=true";
import { default as request_45linkUHERNN_baZYdPe7r32eEayLHMwvSPaPp0k0A5e9_l3cMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/request-link.vue?macro=true";
import { default as newhskaOplo9k8IjTWxTacx_45knNBNfXBRIa2Ihv1HIPSYEMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/companies/new.vue?macro=true";
import { default as manage_45catalogWasMdmfun5J0PWMlZwJ2iukY7PAf__45Ns2IaTCcrnadUMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/manage-catalog.vue?macro=true";
import { default as indexOtjuJ_45iwcPe_2IWpFViFIM8ycMr0zc34D4ypCpQR9lYMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/companies/index.vue?macro=true";
import { default as editCCxP_45ujSroaFXovY2B9ysDrKqVjxrI_45b8wjNHcYCyfMMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/persoonsgegevens/edit.vue?macro=true";
import { default as indexXTagGVedUKsN1YxxJYtiO6rrofa4RoE8sNjKhYSVhSYMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/persoonsgegevens/index.vue?macro=true";
import { default as persoonsgegevensfTAktAEwjujg0f0WXoUPB6ppS7jeV75_452zKLCbBCs80Meta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/persoonsgegevens.vue?macro=true";
import { default as vragenlijstGyZSBKyiU1QDHd1JktPtVV9wajiKQWMJeIMW6tGXb7MMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/stigas/vragenlijst.vue?macro=true";
import { default as voorwaarden_45afgewezen7_7AvqKWngHJwZMBZzThWOnbGgbPrkk8Pqzi1XUKo_MMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/voorwaarden-afgewezen.vue?macro=true";
import { default as indexyRBTeNFgWWRcCPNlWpQEJJmJzL0eJcnMgVnMXUECy30Meta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/application-users/index.vue?macro=true";
import { default as _91userId_93bhY4gJVzpgYohXWYXNO60mJp3R2C01ISbH8NOsc7420Meta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/application-users/[userId].vue?macro=true";
import { default as uitnodigen9QX1cNxweYzrY2JNXukD7_45Snq2ykx5ybAELKX8G1vxUMeta } from "/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/application-users/uitnodigen.vue?macro=true";
export default [
  {
    name: helprI5zHuKNHvrIiu5BHMoJJulzSXZmV875mxwgaIgcgnIMeta?.name ?? "help",
    path: "/help",
    meta: helprI5zHuKNHvrIiu5BHMoJJulzSXZmV875mxwgaIgcgnIMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/help.vue")
  },
  {
    name: indexjMYzAYOqPrOoUNRPe_45hZ8qfNRETGn3rVX3i6SLBrVYMMeta?.name ?? "index",
    path: "/",
    meta: indexjMYzAYOqPrOoUNRPe_45hZ8qfNRETGn3rVX3i6SLBrVYMMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/index.vue")
  },
  {
    name: loginRY5pVAHNAiBy4jVwdsOyuRHQxajIl5a0OEto5VxLsS0Meta?.name ?? "login",
    path: "/login",
    meta: loginRY5pVAHNAiBy4jVwdsOyuRHQxajIl5a0OEto5VxLsS0Meta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/login.vue")
  },
  {
    name: logoutb04bx8vEbZfwsMC9_45ft8jhp_S4xsO7HEjtwclM6oDogMeta?.name ?? "logout",
    path: "/logout",
    meta: logoutb04bx8vEbZfwsMC9_45ft8jhp_S4xsO7HEjtwclM6oDogMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/logout.vue")
  },
  {
    name: privacyYAfuxGKNqN9CkdUzrRGaCVB_6bdQGYVeUww2wcLrrMQMeta?.name ?? "privacy",
    path: "/privacy",
    meta: privacyYAfuxGKNqN9CkdUzrRGaCVB_6bdQGYVeUww2wcLrrMQMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/privacy.vue")
  },
  {
    name: _91companyId_93wG_4569ps_pLTeOKGntd2VqRFXfcMUK_45OjU77JsmL1tpEMeta?.name,
    path: "/:companyId()",
    meta: _91companyId_93wG_4569ps_pLTeOKGntd2VqRFXfcMUK_45OjU77JsmL1tpEMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId].vue"),
    children: [
  {
    name: riedUqUeTbgcyACnXQpxS2CQrEx5uuyGwtKvAI46bc_45nKYMeta?.name,
    path: "rie",
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/rie.vue"),
    children: [
  {
    name: newHhNZSsPw86v_45crBznLBvOd6YAZ8qBCQ5KX_hnVMCFbkMeta?.name ?? "companyId-rie-new",
    path: "new",
    meta: newHhNZSsPw86v_45crBznLBvOd6YAZ8qBCQ5KX_hnVMCFbkMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/rie/new.vue")
  },
  {
    name: indexTAg_45GDTNIb0tduAXM4fHMrRqBAJAUJgtWdOXQ3E87kUMeta?.name ?? "companyId-rie",
    path: "",
    meta: indexTAg_45GDTNIb0tduAXM4fHMrRqBAJAUJgtWdOXQ3E87kUMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/rie/index.vue")
  },
  {
    name: editLrlqi9LrcbGLZZw3XOSU5UYwernZe0TAxIRcCAUTrmwMeta?.name ?? "companyId-rie-rieId-edit",
    path: ":rieId()/edit",
    meta: editLrlqi9LrcbGLZZw3XOSU5UYwernZe0TAxIRcCAUTrmwMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/rie/[rieId]/edit.vue")
  },
  {
    name: indexctiu9Sf7RL95p03SBO54LZosl9EBSQ0fbCZfAorW2WEMeta?.name ?? "companyId-rie-rieId",
    path: ":rieId()",
    meta: indexctiu9Sf7RL95p03SBO54LZosl9EBSQ0fbCZfAorW2WEMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/rie/[rieId]/index.vue")
  }
]
  },
  {
    name: indexQoYH_45KDt3HY4y0nTaAxanVb0fQJYm53O3ah7hPf2Sj8Meta?.name ?? "companyId",
    path: "",
    meta: indexQoYH_45KDt3HY4y0nTaAxanVb0fQJYm53O3ah7hPf2Sj8Meta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/index.vue")
  },
  {
    name: "companyId-rieId",
    path: ":rieId()",
    meta: _91rieId_93sDUUfG6fa5OD8_45HS7WgzoJfMiOpxwE6r5B613wpYpkcMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId].vue"),
    children: [
  {
    name: risicosyPMVIjZWUC1VNMYFwugCMlRO00_45kmClonGz0oP34FywMeta?.name,
    path: "risicos",
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/risicos.vue"),
    children: [
  {
    name: indexrPyrRtpzk2POXSTKfR_IU3skZIRBaLYrqqls61rjOmAMeta?.name ?? "companyId-rieId-risicos",
    path: "",
    meta: indexrPyrRtpzk2POXSTKfR_IU3skZIRBaLYrqqls61rjOmAMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/risicos/index.vue")
  },
  {
    name: editsijRsS5_45vE2Wa_2o7aJnQnu8XtTWwPEZsyX3sjLt1WMMeta?.name ?? "companyId-rieId-risicos-riskId-edit",
    path: ":riskId()/edit",
    meta: editsijRsS5_45vE2Wa_2o7aJnQnu8XtTWwPEZsyX3sjLt1WMMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/risicos/[riskId]/edit.vue")
  },
  {
    name: indexGpmPn6UV0OxqQ7jlzZUngoHx28YUYa9kVMjGbT_45qErkMeta?.name ?? "companyId-rieId-risicos-riskId",
    path: ":riskId()",
    meta: indexGpmPn6UV0OxqQ7jlzZUngoHx28YUYa9kVMjGbT_45qErkMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/risicos/[riskId]/index.vue")
  }
]
  },
  {
    name: dashboardOZ4kUpHOOQMUBBc9W25koILNJVOLDsjRSiGrA1mUTaQMeta?.name ?? "companyId-rieId-dashboard",
    path: "dashboard",
    meta: dashboardOZ4kUpHOOQMUBBc9W25koILNJVOLDsjRSiGrA1mUTaQMeta || {},
    alias: ["","dashboard"],
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/dashboard.vue")
  },
  {
    name: rapportagephZb8VnLEqWDv_8mecsj8_45gacp21WY_xsqiNQkWFgu4Meta?.name,
    path: "rapportage",
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/rapportage.vue"),
    children: [
  {
    name: indexp8r103lKWvLPUEpyPw098SRdLYcFNJ9ds0c_45Vtq2pT4Meta?.name ?? "companyId-rieId-rapportage",
    path: "",
    meta: indexp8r103lKWvLPUEpyPw098SRdLYcFNJ9ds0c_45Vtq2pT4Meta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/rapportage/index.vue")
  },
  {
    name: aanmaken0xY7bcyggNhRgrULqHImBXfTM88_45wsq1JMZY3s6d7EQMeta?.name ?? "companyId-rieId-rapportage-aanmaken",
    path: "aanmaken",
    meta: aanmaken0xY7bcyggNhRgrULqHImBXfTM88_45wsq1JMZY3s6d7EQMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/rapportage/aanmaken.vue")
  }
]
  },
  {
    name: inventarisatiegXCUZcode63G2c728EM_45wqI9EPuC9A4DS0xxvrQ1nOAMeta?.name,
    path: "inventarisatie",
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/inventarisatie.vue"),
    children: [
  {
    name: index9s9MkXplFshKaW_xLZe_45Vy8InJ7pIjwzNXu9LMt_gz8Meta?.name ?? "companyId-rieId-inventarisatie",
    path: "",
    meta: index9s9MkXplFshKaW_xLZe_45Vy8InJ7pIjwzNXu9LMt_gz8Meta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/inventarisatie/index.vue")
  },
  {
    name: onderwerpenC3M_4133WEtEweNRUN0i5msVpBBDTtCY_3ZKetz9eHgMeta?.name ?? "companyId-rieId-inventarisatie-onderwerpen",
    path: "onderwerpen",
    meta: onderwerpenC3M_4133WEtEweNRUN0i5msVpBBDTtCY_3ZKetz9eHgMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/inventarisatie/onderwerpen.vue")
  },
  {
    name: endk7bOGGqkpm9YSP2_zn5XcRciSMv0TOBabTIPhZsQlgsMeta?.name ?? "companyId-rieId-inventarisatie-topicKey-end",
    path: ":topicKey()/end",
    meta: endk7bOGGqkpm9YSP2_zn5XcRciSMv0TOBabTIPhZsQlgsMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/inventarisatie/[topicKey]/end.vue")
  },
  {
    name: indexiOa45rFI3x9S59TBNi9D4Sht8_45Jv8RjDrwJ8CAn_451TEMeta?.name ?? "companyId-rieId-inventarisatie-topicKey",
    path: ":topicKey()",
    meta: indexiOa45rFI3x9S59TBNi9D4Sht8_45Jv8RjDrwJ8CAn_451TEMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/inventarisatie/[topicKey]/index.vue")
  },
  {
    name: _91questionKey_93qWhigDu1jPAu0gPXxTQsW3dU120uIkvvB_45QRCe6Z1ZYMeta?.name ?? "companyId-rieId-inventarisatie-topicKey-questionKey",
    path: ":topicKey()/:questionKey()",
    meta: _91questionKey_93qWhigDu1jPAu0gPXxTQsW3dU120uIkvvB_45QRCe6Z1ZYMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/inventarisatie/[topicKey]/[questionKey].vue")
  }
]
  },
  {
    name: plan_45van_45aanpakJW_8JHBblcI84ufrC2KETdVu5ua7Ekisf6tDyBHHKrsMeta?.name,
    path: "plan-van-aanpak",
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/plan-van-aanpak.vue"),
    children: [
  {
    name: indexKJ_ocGLjjSLHM_45HisHqffKI6jol_45tU6uiLKZR9pm1PEMeta?.name ?? "companyId-rieId-plan-van-aanpak",
    path: "",
    meta: indexKJ_ocGLjjSLHM_45HisHqffKI6jol_45tU6uiLKZR9pm1PEMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/plan-van-aanpak/index.vue")
  },
  {
    name: editQ5OeU6yxsxOzt2De1zRDLbKxIYzq1lrpLBvMOipMVFoMeta?.name ?? "companyId-rieId-plan-van-aanpak-actionId-edit",
    path: ":actionId()/edit",
    meta: editQ5OeU6yxsxOzt2De1zRDLbKxIYzq1lrpLBvMOipMVFoMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/plan-van-aanpak/[actionId]/edit.vue")
  },
  {
    name: indexlQZqI9DMLpK601eHaFOsbDqsOcgOEOvgTbg2Zmu_kQgMeta?.name ?? "companyId-rieId-plan-van-aanpak-actionId",
    path: ":actionId()",
    meta: indexlQZqI9DMLpK601eHaFOsbDqsOcgOEOvgTbg2Zmu_kQgMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/plan-van-aanpak/[actionId]/index.vue")
  }
]
  },
  {
    name: indexk8AtROf2bkuB5Z_saipss2jHyn17oy0gK1bk9_zLh3gMeta?.name ?? "companyId-rieId-stigas-werknemersvragenlijst",
    path: "stigas/werknemersvragenlijst",
    meta: indexk8AtROf2bkuB5Z_saipss2jHyn17oy0gK1bk9_zLh3gMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/[rieId]/stigas/werknemersvragenlijst/index.vue")
  }
]
  },
  {
    name: gebruikerssMjzsIwfYWun8dQ_IxDfFzt_45eP00DZF5ixHppV71h7kMeta?.name,
    path: "gebruikers",
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/gebruikers.vue"),
    children: [
  {
    name: indexth3NAHKiUDWSa8BIcQ9Y4O6PmdrMmY_459LYrUIKoueNEMeta?.name ?? "companyId-gebruikers",
    path: "",
    meta: indexth3NAHKiUDWSa8BIcQ9Y4O6PmdrMmY_459LYrUIKoueNEMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/gebruikers/index.vue")
  },
  {
    name: _91userId_93B5Bt_45Z7LAaWgACFqAfhcvm1LQboLcsOIGOlQ4aUp5HgMeta?.name ?? "companyId-gebruikers-userId",
    path: ":userId()",
    meta: _91userId_93B5Bt_45Z7LAaWgACFqAfhcvm1LQboLcsOIGOlQ4aUp5HgMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/gebruikers/[userId].vue")
  },
  {
    name: uitnodigenPs4oWzm6eE_LvMl4wbnCB8mbL8xRJuReTvYw_45FhznQMMeta?.name ?? "companyId-gebruikers-uitnodigen",
    path: "uitnodigen",
    meta: uitnodigenPs4oWzm6eE_LvMl4wbnCB8mbL8xRJuReTvYw_45FhznQMMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/gebruikers/uitnodigen.vue")
  }
]
  },
  {
    name: bedrijfsinformatiePDcDvenn0ettSilaVhHDsxNkOCjUjRHs2zisbVCpGCYMeta?.name,
    path: "bedrijfsinformatie",
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/bedrijfsinformatie.vue"),
    children: [
  {
    name: editILkwKMIsT_457BBOP_qZLCc7TnEXaR4CtOkQa_N6ixSQgMeta?.name ?? "companyId-bedrijfsinformatie-edit",
    path: "edit",
    meta: editILkwKMIsT_457BBOP_qZLCc7TnEXaR4CtOkQa_N6ixSQgMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/bedrijfsinformatie/edit.vue")
  },
  {
    name: indexr8sejWaWUT_BgKDSMVHD_XKEKsZUE6nDY4Fs6o90Q5sMeta?.name ?? "companyId-bedrijfsinformatie",
    path: "",
    meta: indexr8sejWaWUT_BgKDSMVHD_XKEKsZUE6nDY4Fs6o90Q5sMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/bedrijfsinformatie/index.vue")
  }
]
  },
  {
    name: verantwoordelijkengFxkXY3wcx8r4Efmxl__45l585GZ_452eIafwLBR4UYGKfIMeta?.name,
    path: "verantwoordelijken",
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/verantwoordelijken.vue"),
    children: [
  {
    name: _91id_93kkP8pOsCgBH_DtdY6_gaEtm8PI0cOEG4Z_45mUtvudrzAMeta?.name ?? "companyId-verantwoordelijken-id",
    path: ":id()",
    meta: _91id_93kkP8pOsCgBH_DtdY6_gaEtm8PI0cOEG4Z_45mUtvudrzAMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/verantwoordelijken/[id].vue")
  },
  {
    name: index7qLeRJY8OIQFSPWxEBBiot6idTURnt7ISbxJAqkpYLYMeta?.name ?? "companyId-verantwoordelijken",
    path: "",
    meta: index7qLeRJY8OIQFSPWxEBBiot6idTURnt7ISbxJAqkpYLYMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/verantwoordelijken/index.vue")
  }
]
  },
  {
    name: ongevallenregistratieD6hXoVbHkSn2N9radGPOVtxPWHeruvU4oyGzfWlEpX8Meta?.name,
    path: "ongevallenregistratie",
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/ongevallenregistratie.vue"),
    children: [
  {
    name: new5EkzMZ65HtWV1Z9TXjZyU_450w_458iVdjCI8TpkcRuUY3wMeta?.name ?? "companyId-ongevallenregistratie-new",
    path: "new",
    meta: new5EkzMZ65HtWV1Z9TXjZyU_450w_458iVdjCI8TpkcRuUY3wMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/ongevallenregistratie/new.vue")
  },
  {
    name: index7FvY_H05EDtqKb_7LEe4CZIk67aB5uvMmM0W3vIROxkMeta?.name ?? "companyId-ongevallenregistratie",
    path: "",
    meta: index7FvY_H05EDtqKb_7LEe4CZIk67aB5uvMmM0W3vIROxkMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/ongevallenregistratie/index.vue")
  },
  {
    name: _91accidentId_93dlAQMlAugwFmqCh60zIqCsuWL75fBEjrlvO9T6QFhPkMeta?.name,
    path: ":accidentId()",
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/ongevallenregistratie/[accidentId].vue"),
    children: [
  {
    name: editXZbBnzlX76pZuZTRLWf7TTQPocGNYw36o609YFsUUDAMeta?.name ?? "companyId-ongevallenregistratie-accidentId-edit",
    path: "edit",
    meta: editXZbBnzlX76pZuZTRLWf7TTQPocGNYw36o609YFsUUDAMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/ongevallenregistratie/[accidentId]/edit.vue")
  },
  {
    name: indexTAogjmzEQt8uZY8iKe3RzB_45A4hladUtlaOQU9EPaHWEMeta?.name ?? "companyId-ongevallenregistratie-accidentId",
    path: "",
    meta: indexTAogjmzEQt8uZY8iKe3RzB_45A4hladUtlaOQU9EPaHWEMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/ongevallenregistratie/[accidentId]/index.vue")
  }
]
  },
  {
    name: achtergrondinformatieY6ECRA2lLb8bx_453RcRKDqfAipUfneQ6fau6Oll4sqckMeta?.name ?? "companyId-ongevallenregistratie-achtergrondinformatie",
    path: "achtergrondinformatie",
    meta: achtergrondinformatieY6ECRA2lLb8bx_453RcRKDqfAipUfneQ6fau6Oll4sqckMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/[companyId]/ongevallenregistratie/achtergrondinformatie.vue")
  }
]
  }
]
  },
  {
    name: request_45linkUHERNN_baZYdPe7r32eEayLHMwvSPaPp0k0A5e9_l3cMeta?.name ?? "request-link",
    path: "/request-link",
    meta: request_45linkUHERNN_baZYdPe7r32eEayLHMwvSPaPp0k0A5e9_l3cMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/request-link.vue")
  },
  {
    name: newhskaOplo9k8IjTWxTacx_45knNBNfXBRIa2Ihv1HIPSYEMeta?.name ?? "companies-new",
    path: "/companies/new",
    meta: newhskaOplo9k8IjTWxTacx_45knNBNfXBRIa2Ihv1HIPSYEMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/companies/new.vue")
  },
  {
    name: manage_45catalogWasMdmfun5J0PWMlZwJ2iukY7PAf__45Ns2IaTCcrnadUMeta?.name ?? "manage-catalog",
    path: "/manage-catalog",
    meta: manage_45catalogWasMdmfun5J0PWMlZwJ2iukY7PAf__45Ns2IaTCcrnadUMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/manage-catalog.vue")
  },
  {
    name: indexOtjuJ_45iwcPe_2IWpFViFIM8ycMr0zc34D4ypCpQR9lYMeta?.name ?? "companies",
    path: "/companies",
    meta: indexOtjuJ_45iwcPe_2IWpFViFIM8ycMr0zc34D4ypCpQR9lYMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/companies/index.vue")
  },
  {
    name: persoonsgegevensfTAktAEwjujg0f0WXoUPB6ppS7jeV75_452zKLCbBCs80Meta?.name,
    path: "/persoonsgegevens",
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/persoonsgegevens.vue"),
    children: [
  {
    name: editCCxP_45ujSroaFXovY2B9ysDrKqVjxrI_45b8wjNHcYCyfMMeta?.name ?? "persoonsgegevens-edit",
    path: "edit",
    meta: editCCxP_45ujSroaFXovY2B9ysDrKqVjxrI_45b8wjNHcYCyfMMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/persoonsgegevens/edit.vue")
  },
  {
    name: indexXTagGVedUKsN1YxxJYtiO6rrofa4RoE8sNjKhYSVhSYMeta?.name ?? "persoonsgegevens",
    path: "",
    meta: indexXTagGVedUKsN1YxxJYtiO6rrofa4RoE8sNjKhYSVhSYMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/persoonsgegevens/index.vue")
  }
]
  },
  {
    name: vragenlijstGyZSBKyiU1QDHd1JktPtVV9wajiKQWMJeIMW6tGXb7MMeta?.name ?? "stigas-vragenlijst",
    path: "/stigas/vragenlijst",
    meta: vragenlijstGyZSBKyiU1QDHd1JktPtVV9wajiKQWMJeIMW6tGXb7MMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/stigas/vragenlijst.vue")
  },
  {
    name: voorwaarden_45afgewezen7_7AvqKWngHJwZMBZzThWOnbGgbPrkk8Pqzi1XUKo_MMeta?.name ?? "voorwaarden-afgewezen",
    path: "/voorwaarden-afgewezen",
    meta: voorwaarden_45afgewezen7_7AvqKWngHJwZMBZzThWOnbGgbPrkk8Pqzi1XUKo_MMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/voorwaarden-afgewezen.vue")
  },
  {
    name: indexyRBTeNFgWWRcCPNlWpQEJJmJzL0eJcnMgVnMXUECy30Meta?.name ?? "application-users",
    path: "/application-users",
    meta: indexyRBTeNFgWWRcCPNlWpQEJJmJzL0eJcnMgVnMXUECy30Meta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/application-users/index.vue")
  },
  {
    name: _91userId_93bhY4gJVzpgYohXWYXNO60mJp3R2C01ISbH8NOsc7420Meta?.name ?? "application-users-userId",
    path: "/application-users/:userId()",
    meta: _91userId_93bhY4gJVzpgYohXWYXNO60mJp3R2C01ISbH8NOsc7420Meta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/application-users/[userId].vue")
  },
  {
    name: uitnodigen9QX1cNxweYzrY2JNXukD7_45Snq2ykx5ybAELKX8G1vxUMeta?.name ?? "application-users-uitnodigen",
    path: "/application-users/uitnodigen",
    meta: uitnodigen9QX1cNxweYzrY2JNXukD7_45Snq2ykx5ybAELKX8G1vxUMeta || {},
    component: () => import("/var/lib/jenkins/workspace/branche-rie-build-stigas_master/frontend/pages/application-users/uitnodigen.vue")
  }
]